import { useState, useEffect, useRef } from "react";
import { getActionItemList } from "../redux/services/actionItem.service";
import { getNotificationUnreadCount } from "../redux/services/notification.service";

export const useNotificationCount = (param) => {
  const [notificationCount, setNotificationCount] = useState(0);
  useEffect(() => {
    const getCount = async () => {
      if (location.pathname !== "/notification") {
        var response = await getNotificationUnreadCount();
        if (response.statusCode === 200) {
          setNotificationCount(response.data);
        }
      } else {
        setNotificationCount(0);
      }
    };
    getCount();
  }, [param]);
  return notificationCount;
};
